import { useTranslation } from 'react-i18next'

import { getFileItems } from '../../../../../api'
import { useUk } from '../../../../../hooks'
import {
  ATTACH_ACTION_SELECT_ACTION_FILE,
  ATTACH_ACTION_SELECT_FILE_FROM_STORAGE,
} from '../../../../AttachActionSelect'
import { FileAttachItemsModal } from '../../../../File'

import { getChatroomInputAttachActions } from './useChatroomInputAttach.utils'

export function useChatroomInputAttach({
  outboundUuid,
  selectedStorageFiles,
  onAttachFilesFromStorage,
  onCloseModal,
  onSetModal,
}) {
  const { t } = useTranslation()

  const { directory_id: ukDocumentsFolder } = useUk()

  function handleAttachAction(action) {
    switch (action.value) {
      case ATTACH_ACTION_SELECT_ACTION_FILE:
        // handling action in `AttachActionSelect`
        break
      case ATTACH_ACTION_SELECT_FILE_FROM_STORAGE:
        onSetModal(
          <FileAttachItemsModal
            ButtonRemove={false}
            directoryId={ukDocumentsFolder}
            getData={params => getFileItems(params, { outboundUuid })}
            initialValues={selectedStorageFiles}
            onClose={onCloseModal}
            onSubmit={onAttachFilesFromStorage}
          />
        )
        break
      default:
        return null
    }
  }

  const attachActionOptions = getChatroomInputAttachActions({ t })

  return { attachActionOptions, handleAttachAction }
}
